import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextUnderline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 7a1 1 0 0 0-2 0v8a9 9 0 0 0 18 0V7a1 1 0 1 0-2 0v8a7 7 0 1 1-14 0V7ZM5 26a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H5Z",
		fill: "currentColor"
	})
});
export default SvgTextUnderline;
